// Mirrors build_report_email in the backend's email_config.py: mail sent or
// BCC'd to this address is threaded onto the report.
const INBOUND_DOMAIN = "inbound.luminorrisk.com";

export const reportEmailAddress = (reportId: string): string =>
  `sub+${reportId}@${INBOUND_DOMAIN}`;
